import { createStore } from 'vuex'

const store = createStore({
  state: {
    locale: 'zh-CN'
  },
  getters: {
    currentLocale: (state) => state.locale
  },
  mutations: {
    setLocale(state, locale) {
      state.locale = locale;
    }
  },
  actions: {
    changeLocale({ commit }, locale) {
      commit('setLocale', locale);
    }
  },
  modules: {
  }
})

export default store
